import gql from 'graphql-tag'

export const QUERY_GET_MERCHANT_BASICS = gql`
  query getMerchantBasicsBySlug($slug: String!) {
    merchants(where: { slug: { _eq: $slug } }) {
      id
      name
      description
      slug
    }
  }
`

export const QUERY_GET_MERCHANT = gql`
  query getMerchantBySlug($slug: String!) {
    merchants(where: { slug: { _eq: $slug } }) {
      id
      name
      description
      avatar
      slug
      currency
      website: setting(path: "website")
      welcome_message: setting(path: "welcome_message")
      promotional_banner: setting(path: "promotional_banner")
      closed_store_message: setting(path: "closed_store_message")
      order_note_placeholder: setting(path: "order_note_placeholder")
      same_day_pickup: setting(path: "same_day_pickup")
      same_day_delivery: setting(path: "same_day_delivery")
      scheduled_pickup: setting(path: "scheduled_pickup")
      scheduled_delivery: setting(path: "scheduled_delivery")
      hosts_own_deliveries: setting(path: "hosts_own_deliveries")
      signup_promo_message: setting(path: "signup_promo_message")
      redirect_link: setting(path: "redirect_link")
      tag_manager_id: setting(path: "tag_manager_id")
      pixel_id: setting(path: "pixel_id")
      pre_order_pickup: setting(path: "pre_order_pickup")
      pre_order_delivery: setting(path: "pre_order_delivery")
      pickup_address_enabled: setting(path: "pickup_address_enabled")
      pre_order_settings {
        address: addresses {
          geom
        }
        cutoffs
        delivery_courier_partner
        delivery_zone
        delivery_interval
        delivery_schedule
        delivery_radius
        fixed_courier_fee_enabled
        fixed_delivery_times_enabled
        fixed_delivery_times
        fixed_delivery_times_order_limit
        delivery_timeslots_order_limit
        pickup_timeslots_order_limit
        delivery_enabled
        pickup_enabled
        pre_order_day_allowance
        special_cutoffs
        store_team_preparation
      }
    }
    stores(
      where: {
        archived_at: { _is_null: true }
        merchant: { slug: { _eq: $slug } }
      }
    ) {
      id
      name
      slug
      is_open
      address {
        line_1
        line_2
        city
        zip
        geom
      }
      archived_at
      cutoffs
      special_cutoffs
      advanced_special_schedules
      settings
    }
  }
`
export const QUERY_GET_MERCHANT_STORE = gql`
  query getMerchantAndStoreBySlug($merchant: String!, $slug: String!) {
    merchants(where: { slug: { _eq: $merchant } }) {
      id
      name
      description
      slug
      website: setting(path: "website")
      welcome_message: setting(path: "welcome_message")
      promotional_banner: setting(path: "promotional_banner")
      closed_store_message: setting(path: "closed_store_message")
      order_note_placeholder: setting(path: "order_note_placeholder")
      same_day_pickup: setting(path: "same_day_pickup")
      same_day_delivery: setting(path: "same_day_delivery")
      scheduled_pickup: setting(path: "scheduled_pickup")
      scheduled_delivery: setting(path: "scheduled_delivery")
      signup_promo_message: setting(path: "signup_promo_message")
      redirect_link: setting(path: "redirect_link")
      tag_manager_id: setting(path: "tag_manager_id")
      pixel_id: setting(path: "pixel_id")
      product_search_enabled: setting(path: "product_search_enabled")
      stores(where: { slug: { _eq: $slug }, archived_at: { _is_null: true } }) {
        id
        name
        slug
        is_open
        address {
          line_1
          line_2
          city
          zip
          geom
        }
        archived_at
        cutoffs
        special_cutoffs
        advanced_special_schedules
        settings
      }
    }
  }
`

export const QUERY_GET_MERCHANT_STORES = gql`
  query getStoresByMerchant($slug: String!) {
    stores(
      where: {
        merchant: { slug: { _eq: $slug } }
        archived_at: { _is_null: true }
      }
    ) {
      id
      name
      is_open
      slug
      address {
        zip
      }
      archived_at
      cutoffs
    }
  }
`
